import React from 'react';

const RecycleBin = () => {
  const deletedItems = [
    { name: 'Old Photo.jpg', icon: '/pictures.ico', type: 'JPEG Image', deleted: '8/19/2025 5:45 PM', size: '2.3 MB' },
    { name: 'Draft Document.docx', icon: '/documents.ico', type: 'Microsoft Word', deleted: '8/18/2025 11:20 AM', size: '45 KB' },
    { name: 'Temp Folder', icon: '/documents.ico', type: 'File Folder', deleted: '8/17/2025 9:15 AM', size: '-' }
  ];

  return (
    <div style={{ 
      padding: '8px', 
      fontSize: '11px', 
      fontFamily: 'Tahoma, sans-serif',
      height: '100%',
      overflow: 'auto'
    }}>
      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
          Recycle Bin Tasks
        </h3>
        <div style={{ 
          background: '#e6f3ff', 
          border: '1px solid #b3d9ff', 
          padding: '8px',
          borderRadius: '3px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <div style={{ color: '#0066cc', cursor: 'pointer' }}>Empty the Recycle Bin</div>
            <div style={{ color: '#0066cc', cursor: 'pointer' }}>Restore all items</div>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <h3 style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>
          Other Places
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>Desktop</div>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>My Documents</div>
          <div style={{ color: '#0066cc', cursor: 'pointer', padding: '2px 0' }}>My Computer</div>
        </div>
      </div>

      <div>
        {deletedItems.length > 0 ? (
          <>
            <div style={{ 
              borderBottom: '1px solid #ccc', 
              paddingBottom: '4px', 
              marginBottom: '8px',
              display: 'grid',
              gridTemplateColumns: '1.5fr 1.5fr 1fr 0.7fr 1fr',
              gap: '8px',
              fontWeight: 'bold',
              color: '#666'
            }}>
              <span>Name</span>
              <span>Original Location</span>
              <span>Date Deleted</span>
              <span>Size</span>
              <span>Type</span>
            </div>
            
            <div>
              {deletedItems.map((item, index) => (
                <div key={index} style={{ 
                  display: 'grid',
                  gridTemplateColumns: '1.5fr 1.5fr 1fr 0.7fr 1fr',
                  gap: '8px',
                  padding: '4px 0',
                  cursor: 'pointer',
                  borderRadius: '2px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={item.icon} alt={item.name} style={{ width: '16px', height: '16px', marginRight: '6px' }} />
                    <span>{item.name}</span>
                  </div>
                  <span style={{ color: '#666', fontSize: '10px' }}>C:\Documents and Settings\User\Desktop</span>
                  <span style={{ color: '#666' }}>{item.deleted}</span>
                  <span style={{ color: '#666' }}>{item.size}</span>
                  <span style={{ color: '#666' }}>{item.type}</span>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '32px 0' }}>
            <img src="/recycle-bin.ico" alt="Empty Recycle Bin" style={{ 
              width: '64px', 
              height: '64px', 
              margin: '0 auto 16px auto', 
              opacity: 0.5,
              display: 'block'
            }} />
            <p style={{ color: '#666', fontSize: '12px' }}>The Recycle Bin is empty.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecycleBin;
